















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  UploadFile,
  GetResourceList,
  EditResource,
  DelResource,
  GetMulu,
} from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  private editData: any = {};
  private zhishidians: any = [];
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            ids: [item.ziyuan_id],
          },
        };
        DelResource(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private delAll() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择需要删除的数据");
      return;
    }
    this.$confirm("您确定要删除所选数据么？", "批量删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      let ids: any = [];
      this.selectedMessages.forEach((ele: any) => {
        ids.push(ele.ziyuan_id);
      });

      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          ids: ids,
        },
      };
      DelResource(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("批量删除成功");
          this.selectedMessages = [];
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private upload(file: any, item?: any) {
    if (item) {
      this.editData = item;
    } else {
      this.editData = {
        类别: "课件",
        file_list: [],
      };
    }
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form).then((res: any) => {
      this.editData["名称"] = file.file.name;
      this.editData.file_list = [res.full_file_url];
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      EditResource(this, this.editData, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success(
            `${this.editData.ziyuan_id ? "上传" : "添加"}` + "成功"
          );
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      类别: "课件",
      chapter_id: this.filters["知识点"],
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("resourceFilter", JSON.stringify(this.filters));
    GetResourceList(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          const inc = this.selectedMessages.findIndex((i: any) => {
            return i["ziyuan_id"] === element["ziyuan_id"];
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getZhishidian() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetMulu(this, {})
      .then((res: any) => {
        loading.close();
        this.zhishidians = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private goZhishidian(item: any) {
    this.$router.push({
      path: "/main/teacher/textbook-resources",
      query: {
        data: JSON.stringify(item),
        type: "课件",
      },
    });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("resourceFilter")) {
      this.filters = JSON.parse(localStorage.getItem("resourceFilter") as any);
    }
    this.getList();
    this.getZhishidian();
  }
}
